import styles from './guestcheckbox.module.scss';
import { GuestCheckboxProps } from '@msc-b2c/interfaces/types';
import React, { useRef } from 'react';

export const GuestCheckbox = ({
  id,
  ariaLabel,
  ariaLabelledBy,
  onChange,
  checked,
  tabIndex,
  disabled,
}: GuestCheckboxProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled && onChange) {
      onChange(event);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLLabelElement>) => {
    // Handle spacebar and enter to toggle checkbox
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      if (!disabled && inputRef.current) {
        inputRef.current.click(); // This properly triggers React's onChange handler
      }
    }
  };

  return (
    <div className={styles['cmp-guest-checkbox']}>
      <input
        ref={inputRef}
        type="checkbox"
        id={id}
        aria-label={ariaLabelledBy ? undefined : ariaLabel}
        aria-labelledby={ariaLabelledBy}
        onChange={handleChange}
        checked={checked}
        tabIndex={-1}
        disabled={disabled || false}
      />
      <label
        htmlFor={id}
        onKeyDown={handleKeyDown}
        tabIndex={disabled ? -1 : tabIndex || 0}
        role="checkbox"
        aria-checked={checked}
        aria-labelledby={ariaLabelledBy}
        aria-label={ariaLabelledBy ? undefined : ariaLabel}
      ></label>
    </div>
  );
};
